import { useEffect, useState } from "react"
import { fileTypes } from "../../common/constants/constants"
import { downloadLink } from "../../common/utils/common-utils"
import { getBimProductDownloadUrl } from "./queries"

const useBimData = (productId: string, locale: string) => {
  const [bimDownloadUrl, setBimDownloadUrl] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const downloadBimUrl = () => {
    bimDownloadUrl && downloadLink(bimDownloadUrl, productId, fileTypes.BIM)
  }

  useEffect(() => {
    if (!productId || !locale) return

    const getBimData = async () => {
      try {
        setIsLoading(true) // Set loading to true
        const bimResult = await getBimProductDownloadUrl(productId, locale)
        setBimDownloadUrl(bimResult)
      } catch (error) {
        console.error("Failed to fetch BIM data:", error)
        setBimDownloadUrl(null)
      } finally {
        setIsLoading(false)
      }
    }

    getBimData()
  }, [productId, locale])

  return { bimDownloadUrl, isLoading, downloadBimUrl } // Expose loading state and BIM data
}

export default useBimData
